module.exports = __webpack_public_path__ + "static/img/萌宫天街1.2e391c52.png";